import ActionTypes from './ActionTypes';
export default {
  init: function init() {
    return {
      type: ActionTypes.INIT
    };
  },
  push: function push(location) {
    return {
      type: ActionTypes.PUSH,
      payload: location
    };
  },
  replace: function replace(location) {
    return {
      type: ActionTypes.REPLACE,
      payload: location
    };
  },
  go: function go(delta) {
    return {
      type: ActionTypes.GO,
      payload: delta
    };
  },
  dispose: function dispose() {
    return {
      type: ActionTypes.DISPOSE
    };
  }
};